var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"list"},_vm._l((this.$store.getters.SELECTED),function(enrolleeId){return _c('Element',{key:enrolleeId,attrs:{"enrolleeId":enrolleeId}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }